/* ==========================================================
   FeierabendGenuss – Theme-Script
   Alle Inhalte kommen aus dem Theme-Editor; hier nur Verhalten.
   ========================================================== */
(function () {
  "use strict";

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const pad = (n) => String(n).padStart(2, "0");
  const isEditor = () => document.body.classList.contains("is-design-mode");

  /* ---------------- Countdown (ein globaler Takt für alle Countdowns) ---------------- */
  const Countdown = {
    timer: null,
    end: NaN,
    init() {
      this.end = new Date(document.body.dataset.giveawayEnd || "").getTime();
      if (isNaN(this.end)) return;
      this.tick();
      if (!this.timer) this.timer = setInterval(() => this.tick(), 1000);
    },
    tick() {
      if (isNaN(this.end)) return;
      const diff = this.end - Date.now();
      const ended = diff <= 0;
      const d = ended ? 0 : Math.floor(diff / 86400000);
      const h = ended ? 0 : Math.floor((diff % 86400000) / 3600000);
      const m = ended ? 0 : Math.floor((diff % 3600000) / 60000);
      const s = ended ? 0 : Math.floor((diff % 60000) / 1000);

      $$("[data-countdown]").forEach((el) => {
        if (ended) { el.classList.add("is-ended"); return; }
        const set = (k, v) => { const n = $(`[data-cd='${k}']`, el); if (n) n.textContent = pad(v); };
        set("d", d); set("h", h); set("m", m); set("s", s);
      });

      $$("[data-countdown-compact]").forEach((el) => {
        if (ended) {
          el.textContent = document.body.dataset.giveawayEnded || "";
        } else {
          const prefix = el.dataset.prefix ? el.dataset.prefix + " " : "";
          el.textContent = `${prefix}${d} T · ${pad(h)}:${pad(m)}:${pad(s)}`;
        }
      });

      if (ended && this.timer) { clearInterval(this.timer); this.timer = null; }
    }
  };

  /* ---------------- Produktgalerie ---------------- */
  function initGallery(root) {
    $$("[data-gallery]", root).forEach((gallery) => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = "1";
      const track = $("[data-gallery-track]", gallery);
      const slides = $$("[data-gallery-slide]", gallery);
      const thumbs = $$("[data-gallery-thumb]", gallery);
      const prev = $("[data-gallery-prev]", gallery);
      const next = $("[data-gallery-next]", gallery);
      if (!track || slides.length < 2) return;

      let current = 0;
      const goTo = (i) => {
        const idx = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[idx].offsetLeft, behavior: "smooth" });
      };
      const setActive = (idx) => {
        current = idx;
        thumbs.forEach((t, n) => {
          const active = n === idx;
          t.classList.toggle("is-active", active);
          if (active) { t.setAttribute("aria-current", "true"); } else { t.removeAttribute("aria-current"); }
        });
        if (prev) prev.disabled = idx === 0;
        if (next) next.disabled = idx === slides.length - 1;
        const activeThumb = thumbs[idx];
        if (activeThumb && activeThumb.parentElement) {
          activeThumb.parentElement.scrollIntoView({ block: "nearest", inline: "nearest" });
        }
      };

      thumbs.forEach((t) => t.addEventListener("click", () => goTo(Number(t.dataset.galleryThumb))));
      if (prev) prev.addEventListener("click", () => goTo(current - 1));
      if (next) next.addEventListener("click", () => goTo(current + 1));
      track.addEventListener("keydown", (e) => {
        if (e.key === "ArrowRight") { e.preventDefault(); goTo(current + 1); }
        if (e.key === "ArrowLeft") { e.preventDefault(); goTo(current - 1); }
      });

      let raf = null;
      track.addEventListener("scroll", () => {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const idx = Math.round(track.scrollLeft / track.clientWidth);
          if (idx !== current) setActive(idx);
        });
      }, { passive: true });

      setActive(0);
    });
  }

  /* ---------------- Guides ein-/ausklappen ---------------- */
  function initGuides(root) {
    $$("[data-toggle-guides]", root).forEach((btn) => {
      if (btn.dataset.ready) return;
      btn.dataset.ready = "1";
      const section = btn.closest("section");
      const grid = section && $("[data-guides]", section);
      if (!grid) return;
      btn.addEventListener("click", () => {
        const collapsed = grid.classList.toggle("is-collapsed");
        btn.setAttribute("aria-expanded", String(!collapsed));
        btn.textContent = collapsed ? btn.dataset.labelMore : btn.dataset.labelLess;
        if (collapsed) grid.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  /* ---------------- FAQ: immer nur ein Eintrag offen ---------------- */
  function initFaq(root) {
    $$("[data-faq]", root).forEach((faq) => {
      if (faq.dataset.ready) return;
      faq.dataset.ready = "1";
      const items = $$("details", faq);
      items.forEach((item) => item.addEventListener("toggle", () => {
        if (item.open) items.forEach((o) => { if (o !== item) o.open = false; });
      }));
    });
  }

  /* ---------------- Sticky-Kaufleiste ---------------- */
  const Sticky = {
    observers: [],
    init() {
      this.observers.forEach((o) => o.disconnect());
      this.observers = [];
      const bar = $("[data-sticky]");
      if (!bar) return;

      const anchor = $("[data-hero-cta]");
      const footer = $(".footer");
      let anchorPassed = !anchor;
      let footerVisible = false;

      const update = () => {
        const show = anchorPassed && !footerVisible && (anchor || window.scrollY > 500);
        bar.classList.toggle("is-visible", Boolean(show));
        bar.setAttribute("aria-hidden", String(!show));
        $$("a, button", bar).forEach((el) => el.setAttribute("tabindex", show ? "0" : "-1"));
      };

      if (!("IntersectionObserver" in window)) { bar.classList.add("is-visible"); return; }

      if (anchor) {
        const io = new IntersectionObserver(([e]) => {
          anchorPassed = !e.isIntersecting && e.boundingClientRect.top < 0;
          update();
        });
        io.observe(anchor);
        this.observers.push(io);
      } else {
        window.addEventListener("scroll", update, { passive: true });
      }
      if (footer) {
        const io = new IntersectionObserver(([e]) => { footerVisible = e.isIntersecting; update(); });
        io.observe(footer);
        this.observers.push(io);
      }
      update();
    }
  };

  /* ---------------- Dialoge (Teilnahmebedingungen) ---------------- */
  function openDialog(id) {
    const dlg = document.getElementById(id);
    if (dlg && typeof dlg.showModal === "function" && !dlg.open) dlg.showModal();
  }
  function initDialogs() {
    if (document.body.dataset.dialogsReady) return;
    document.body.dataset.dialogsReady = "1";

    document.addEventListener("click", (e) => {
      const opener = e.target.closest("[data-open-dialog]");
      if (opener) { e.preventDefault(); openDialog(opener.dataset.openDialog); return; }

      const link = e.target.closest("a[href$='#teilnahmebedingungen']");
      if (link && document.getElementById("TermsDialog")) { e.preventDefault(); openDialog("TermsDialog"); return; }

      const closer = e.target.closest("[data-close-dialog]");
      if (closer) { const d = closer.closest("dialog"); if (d) d.close(); return; }

      if (e.target.tagName === "DIALOG") e.target.close(); // Klick auf den Hintergrund
    });

    if (location.hash === "#teilnahmebedingungen") openDialog("TermsDialog");
  }

  /* ---------------- Tracking-Hook (optional: Meta Pixel / GA4) ---------------- */
  function initTracking() {
    if (document.body.dataset.trackingReady) return;
    document.body.dataset.trackingReady = "1";
    document.addEventListener("click", (e) => {
      if (!e.target.closest(".js-buy")) return;
      try {
        if (typeof window.fbq === "function") window.fbq("track", "InitiateCheckout");
        if (typeof window.gtag === "function") window.gtag("event", "begin_checkout");
      } catch (err) { /* ignorieren */ }
    });
  }

  /* ---------------- Einblende-Animation ---------------- */
  let revealObserver = null;
  function initReveal(root) {
    if (isEditor() || !("IntersectionObserver" in window)) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (!revealObserver) {
      revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add("is-in"); revealObserver.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
    }
    $$(".benefit, .step, .guide, .faq__item, .offer__box, .review", root).forEach((el) => {
      if (el.classList.contains("reveal")) return;
      el.classList.add("reveal");
      revealObserver.observe(el);
    });
  }

  /* ---------------- Start ---------------- */
  function initScope(root) {
    initGallery(root);
    initGuides(root);
    initFaq(root);
    initReveal(root);
  }

  function boot() {
    initScope(document);
    Countdown.init();
    Sticky.init();
    initDialogs();
    initTracking();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  /* Theme-Editor: Abschnitte werden live neu geladen */
  document.addEventListener("shopify:section:load", (e) => {
    initScope(e.target);
    Countdown.tick();
    Sticky.init();
  });
  document.addEventListener("shopify:section:unload", () => setTimeout(() => Sticky.init(), 0));
  document.addEventListener("shopify:block:select", (e) => {
    const details = e.target.closest("details") || (e.target.tagName === "DETAILS" ? e.target : null);
    if (details) details.open = true;
    const grid = e.target.closest("[data-guides]");
    if (grid) grid.classList.remove("is-collapsed");
  });
})();
